import ReasonAddPage from './add'
export default ReasonAddPage
